var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Slider as $Slider } from "antd";
import { Field } from "formik";
import * as React from "react";
import './Slider.css';
var SliderWrapper = /** @class */ (function (_super) {
    __extends(SliderWrapper, _super);
    function SliderWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.sliderWrapperRef = React.createRef();
        _this.configDirection = function () {
            if (_this.isRTL && _this.sliderWrapperRef.current) {
                var sliderWrapperEl = _this.sliderWrapperRef.current;
                var sliderEl = sliderWrapperEl.getElementsByTagName('div')[0];
                _this.supportRtlArrowKeys(sliderEl);
                _this.supportRtlStepInteraction(sliderEl);
                _this.supportRtlTextMarksInteraction(sliderEl);
            }
        };
        _this.changeCurrentValue = function (value) {
            _this.props.onChangeValue(value);
            _this.setState({ currentValue: value });
            if (_this.sliderHandle) {
                _this.sliderHandle.innerText = value.toString();
            }
        };
        _this.supportRtlArrowKeys = function (sliderEl) {
            sliderEl.onkeydown = function (e) {
                e.stopPropagation();
                var currentValue = _this.state.currentValue || 0;
                if (e.keyCode === 39) {
                    currentValue--;
                }
                else if (e.keyCode === 37) {
                    currentValue++;
                }
                if (currentValue >= 0 && currentValue <= _this.max) {
                    _this.changeCurrentValue(currentValue);
                }
            };
        };
        _this.supportRtlTextMarksInteraction = function (sliderEl) {
            var textMarks = Array.from(sliderEl.getElementsByClassName('ant-slider-mark-text'));
            var _loop_1 = function (i) {
                var textMark = textMarks[i];
                ['onmousedown', 'ontouchstart'].forEach(function (eventName) {
                    textMark[eventName] = function (e) {
                        e.stopPropagation();
                        var mark = Object.entries(_this.props.marks)[i];
                        if (mark) {
                            _this.changeCurrentValue(Number(mark[0]));
                        }
                    };
                });
            };
            for (var i = 0; i < textMarks.length; i++) {
                _loop_1(i);
            }
        };
        _this.supportRtlStepInteraction = function (sliderEl) {
            var sliderStep = sliderEl.getElementsByClassName('ant-slider-step')[0];
            [
                sliderEl.getElementsByClassName('ant-slider-track')[0],
                sliderEl.getElementsByClassName('ant-slider-rail')[0],
                sliderStep
            ].forEach(function (el) {
                el.onmousedown = function (e) { return e.stopPropagation(); };
                el.onclick = function (e) { return e.stopPropagation(); };
                el.onmouseup = function (e) { return e.stopPropagation(); };
            });
            sliderStep.onmousedown = function (e) {
                e.stopPropagation();
                var rect = sliderStep.getBoundingClientRect();
                var x = rect.width - (e.clientX - rect.left);
                var stepWidth = rect.width / _this.max;
                var currentStep = Math.round(x / stepWidth);
                _this.changeCurrentValue(currentStep);
            };
            sliderStep.onclick = function (e) { return e.stopPropagation(); };
            sliderStep.onmouseup = function (e) { return e.stopPropagation(); };
        };
        _this.isRTL = props.dir === 'rtl';
        // We need max to the future computation
        if (props.max !== undefined) {
            _this.max = props.max;
        }
        else {
            // If it is not given with props then we take max value of marks
            _this.max = Math.max.apply(Math, Object.keys(props.marks || []).map(function (m) { return Number(m); }));
        }
        _this.state = { currentValue: _this.props.defaultValue || 0 };
        return _this;
    }
    SliderWrapper.prototype.componentDidMount = function () {
        this.configDirection();
        if (this.sliderWrapperRef.current) {
            this.sliderHandle = this.sliderWrapperRef.current.getElementsByClassName('ant-slider-handle')[0];
            if (this.sliderHandle) {
                this.sliderHandle.innerText = this.state.currentValue.toString();
            }
        }
    };
    SliderWrapper.prototype.componentDidUpdate = function (oldProps) {
        if (oldProps.dir !== this.props.dir) {
            this.configDirection();
        }
    };
    SliderWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, validate = _a.validate, onChange = _a.onChange, question = _a.question, restProps = __rest(_a, ["name", "validate", "onChange", "question"]);
        var currentValue = this.state.currentValue;
        return (React.createElement("div", { ref: this.sliderWrapperRef },
            React.createElement($Slider, __assign({ value: currentValue, onChange: function (newValue) {
                    if (_this.isRTL) {
                        var rtlValue = _this.max - Number(newValue);
                        newValue = rtlValue;
                    }
                    _this.changeCurrentValue(Number(newValue));
                }, 
                // tipFormatter={val => val === 0 ? null : val}
                tooltipVisible: false }, restProps, (this.isRTL ? { className: 'ant-slider-rtl' } : ''), { max: this.max }))));
    };
    return SliderWrapper;
}(React.PureComponent));
export { SliderWrapper };
export var Slider = function (props) {
    var name = props.name, validate = props.validate, onChange = props.onChange, question = props.question, restProps = __rest(props, ["name", "validate", "onChange", "question"]);
    var _a = JSON.parse(question.params), max = _a.max, marks = _a.marks;
    var lastValue = props.defaultValue || 0;
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
        return (React.createElement(SliderWrapper
        // @ts-ignore
        , __assign({ 
            // @ts-ignore
            defaultValue: props.defaultValue || 0, onChangeValue: function (newValue) {
                setFieldValue(name, newValue.valueOf());
                setFieldTouched(name, true);
                if (lastValue !== newValue) {
                    onChange && onChange(newValue);
                }
                // @ts-ignore
                lastValue = newValue;
            } }, restProps, { max: max, marks: marks.reduce(function (sliderMarks, mark) {
                sliderMarks[mark.value] = mark.label;
                return sliderMarks;
            }, {}) })));
    }));
};
export default Slider;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Slider/Slider.tsx
// module id = 1481
// module chunks = 0